import { render, staticRenderFns } from "./LoadMore.vue?vue&type=template&id=66b0d918&scoped=true&"
import script from "./LoadMore.vue?vue&type=script&lang=js&"
export * from "./LoadMore.vue?vue&type=script&lang=js&"
import style0 from "./LoadMore.vue?vue&type=style&index=0&id=66b0d918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b0d918",
  null
  
)

export default component.exports